<template>
  <div>
    <div :class="open?'cardOpen':'card'"
         @mouseenter="changeOpen">
      <div class="cardContent">
        <div class="cardTitle" v-html="title">{{title}}</div>
        <div class="cardSubTitle" v-html="subTitle">{{subTitle}}</div>
        <div class="cardBg">
          <img
            draggable='false'
            :src="img"
            alt=''
            width='100%'
            height='100%'
            layout='responsive'
            objectFit='contain'
          />
        </div>
      </div>
      <div class="cardName">{{name}}</div>
    </div>
  </div>

</template>

<script>
  export default {
    props:['open','title','subTitle','img','name','onOpen'],
    data(){
      return {

      }
    },
    methods: {
      changeOpen(){
        this.onOpen(this.name)
      }
    }
  }
</script>

<style scoped>
.card {
  width: var(--card-collapse-width);
  height: var(--card-height);
  max-height: var(--card-height);
  overflow: hidden;
  position: relative;
  border-radius: 20px;
  background-color: #ec9228;
  opacity: 0.7;
  transition: all 0.5s ease-in-out;
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  color: white;
}

.cardOpen {
  height: var(--card-height);
  max-height: var(--card-height);
  overflow: hidden;
  position: relative;
  border-radius: 20px;
  background-color: #ec9228;
  transition: all 0.5s ease-in-out;
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  color: white;
  opacity: 1;
  width: var(--card-expand-width, calc(90vw / 3));
}

.cardName {
  flex: 0 0 var(--card-collapse-width);
  width: var(--card-collapse-width);
  writing-mode: vertical-lr;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 12px;
  padding: 30px 0;
}

.cardContent {
  flex: 0 0 0;
  opacity: 0;
  width: 0;
  transition: width 0.5s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.cardContent > *:first-child {
  margin-bottom: 16px !important;
}

.cardOpen .cardContent {
  opacity: 1;
  flex-basis: calc(var(--card-expand-width, calc(90vw / 3)) - 2*var(--card-collapse-width));
  width: calc(var(--card-expand-width, calc(90vw / 3)) - 2*var(--card-collapse-width));
  padding: 40px;
}

.cardTitle {
  font-size: 18px;
  font-weight: bold;
}

@media screen and (max-width: 1024px){
  .cardTitle {
    font-size: 19px;
  }
}

.cardSubTitle {
  font-size: 10px;
  font-weight: bold;
}

.cardBg {
  position: absolute;
  top: 5%;
  right: 5%;
  width: 50%;
  height: 50%;
}


</style>
